import { X, Phone, Info } from 'lucide-react';

interface DoctorCallModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function DoctorCallModal({ isOpen, onClose }: DoctorCallModalProps) {
  if (!isOpen) return null;

  const doctorName = "Nils Zaenker";
  const phoneNumber = "+4915206413153";
  const displayNumber = "+49 152 06413153";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b">
          <h2 className="text-xl font-semibold text-gray-900">Info vom Arzt</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-5">
          {/* Doctor Info */}
          <div className="text-center pb-4 border-b">
            <div className="w-16 h-16 bg-[#6D4AFF]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Phone className="w-8 h-8 text-[#6D4AFF]" />
            </div>
            <p className="text-lg font-medium text-gray-900">{doctorName}</p>
            <p className="text-sm text-gray-600">Arzt & CEO von Ivelion</p>
            <p className="text-gray-500 mt-1">{displayNumber}</p>
          </div>

          {/* Disclaimer Section */}
          <div className="space-y-3">
            {/* What this service is for */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="flex gap-3">
                <Info className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" />
                <div className="text-sm text-blue-800">
                  <p className="font-medium mb-1">Dieses Angebot ist ausschließlich für:</p>
                  <ul className="list-disc list-inside space-y-0.5 text-blue-700">
                    <li>Fragen zu klinischen Studien</li>
                    <li>Fragen zur App-Nutzung</li>
                    <li>Fragen zur Ergebnisdarstellung</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Emergency Notice */}
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
              <p className="text-xs text-amber-700">
                <span className="font-medium">Bei Notfällen:</span> Notruf 112 oder ärztlicher Bereitschaftsdienst 116117
              </p>
            </div>

            {/* Privacy Notice */}
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
              <p className="text-xs text-gray-600">
                <span className="font-medium">Datenschutzhinweis:</span> Bei einem Telefongespräch können Gesundheitsdaten übermittelt werden. Teilen Sie nur Informationen, die für Ihre Anfrage notwendig sind.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Abbrechen
            </button>
            <a
              href={`tel:${phoneNumber}`}
              onClick={onClose}
              className="flex-1 px-4 py-2 bg-[#6D4AFF] text-white rounded-lg hover:bg-[#5A3AD4] transition-colors text-center"
            >
              Anrufen
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
